import React from 'react';

export function SkeletonLine({ className = '', width = 'w-full' }) {
  return <div className={`skeleton h-3 rounded ${width} ${className}`} />;
}

export function SkeletonCard({ className = '' }) {
  return (
    <div className={`bg-white rounded-lg border border-slate-200 p-5 space-y-3 ${className}`}>
      <SkeletonLine width="w-1/3" />
      <SkeletonLine className="h-8" width="w-1/2" />
      <SkeletonLine width="w-2/3" />
    </div>
  );
}

export function SkeletonGrid({ count = 4, className = '' }) {
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 ${className}`}>
      {[...Array(count)].map((_, i) => <SkeletonCard key={i} />)}
    </div>
  );
}
